import { render } from "./Kode_AI_Widget.vue?vue&type=template&id=ddd7b5e2&scoped=true"
import script from "./Kode_AI_Widget.vue?vue&type=script&lang=js"
export * from "./Kode_AI_Widget.vue?vue&type=script&lang=js"

import "./Kode_AI_Widget.vue?vue&type=style&index=0&id=ddd7b5e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddd7b5e2"]])

export default __exports__